import { useGetIdentity, useTranslate } from "ra-core";
import { Link } from "react-router";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { AlertBell } from "./AlertList";
import { detectPlatform, installState } from "./installApp";
import { isStandalone, useInstallPrompt } from "./installPrompt";
import { ProjectDashboard } from "./ProjectDashboard";

/** Accueil sur téléphone : le tableau de bord, avec les alertes et le compte en haut. */
export const MobileHome = () => (
  <>
    <MobileHeader>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <img src="./appIcon/192.png" alt="" className="size-7 rounded-md" />
        <span className="text-lg font-semibold">Aubeon</span>
      </div>
      <AlertBell />
      <AccountButton />
    </MobileHeader>
    <MobileContent>
      <ProjectDashboard />
    </MobileContent>
  </>
);

/** Avatar menant aux paramètres ; une pastille tant que l'application reste à installer. */
const AccountButton = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const { promptAvailable, installed } = useInstallPrompt();
  const state = installState({
    standalone: isStandalone(),
    platform: detectPlatform(navigator.userAgent, navigator.maxTouchPoints),
    promptAvailable,
    installed,
  });
  const toInstall = state !== "hidden" && state !== "installed";
  const initials = (identity?.fullName ?? "")
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return (
    <Link
      to="/settings"
      className="relative ml-1 rounded-full"
      aria-label={translate(
        toInstall ? "crm.navigation.account_install" : "crm.settings.title",
      )}
    >
      <Avatar className="size-8">
        {identity?.avatar && <AvatarImage src={identity.avatar} alt="" />}
        <AvatarFallback className="text-xs">{initials}</AvatarFallback>
      </Avatar>
      {toInstall && (
        <span className="absolute -top-0.5 -right-0.5 size-2.5 rounded-full bg-signal ring-2 ring-card" />
      )}
    </Link>
  );
};
